import { THREATEN_ACTIONS } from "game-common/ember_sprite/clips"
import { AnimatedFeedbackParams, Entity } from "game-common/models"
import { BodyAnimationPose } from "./animation_pose"

/** The existing windup events drive the body; never synthesize a strike on a local timer. */
export class EmberAttackWarning {
    private startedAt?: number
    private durationMs = 750
    private action = THREATEN_ACTIONS[0]

    feedback(params: AnimatedFeedbackParams, now = Date.now()) {
        if (params.action === "remove" || params.action === "release") this.clear()
        else {
            // Half hold still; the other half is split evenly between the authored gestures.
            const roll = Math.random()
            this.action = roll >= 0.5 ? "idle" : THREATEN_ACTIONS[Math.floor(roll * 2 * THREATEN_ACTIONS.length)]
            this.startedAt = now
            this.durationMs = Math.max(1, params.duration ?? 750)
        }
    }

    clear() { this.startedAt = undefined }

    pose(entity: Entity, facing: string, now = Date.now()): BodyAnimationPose | undefined {
        if (entity.hp <= 0 || entity.isDead()) this.clear()
        if (this.startedAt === undefined) return undefined
        const elapsed = Math.max(0, now - this.startedAt)
        // Same bounded lifetime as the old cue, in case a release packet is lost.
        if (elapsed >= this.durationMs + 180) { this.clear(); return undefined }
        return { action: `${this.action}-${facing}`, progress: this.action === "idle" ? 0 : Math.min(1, elapsed / this.durationMs) }
    }
}
